/**
 * An error that keeps track of its cause and origin.
 *
 * Useful to have full stack information even in event handlers.
 */
export class LinkedError extends Error {
    constructor(message, origin, cause) {
        super(message);
        this.origin = origin;
        this.cause = cause;
    }
}
//# sourceMappingURL=linked-error.js.map